import React, { Component } from "react";
import PropTypes from "prop-types";

import { Input } from "@masterteam/mt-design-react";

import SendIcon from "../icons/SendIcon";
import FileIcon from "../icons/FileIcon";

import "./style.scss";

class UserInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputActive: false,
      inputHasText: false,
      emojiPickerIsOpen: false,
      supportedExtensions: this.reduceSupportedExtensions(
        props.theme.DocumentType.item.Items
      ),
      record: false,
      emojiFilter: "",
    };
  }

  componentDidMount() {
    this.emojiPickerButton = document.querySelector("#sc-emoji-picker-button");
    this.handlePlayToggle = this.handlePlayToggle.bind(this);
  }
  reduceSupportedExtensions(list) {
    const array = [];
    list.map((item) => {
      return array.push(`.${item.Value}`);
    });
    return array;
  }
  handleKeyDown(event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      return this._submitText(event);
    }
    return event;
  }

  handleKeyUp(event) {
    const inputHasText =
      event.target.innerHTML.length !== 0 && event.target.innerText !== "\n";
    this.setState({ inputHasText });
  }

  _showFilePicker() {
    this._fileUploadButton.click();
  }

  toggleEmojiPicker = (e) => {
    const { emojiPickerIsOpen } = this.state;
    e.preventDefault();
    if (!emojiPickerIsOpen) {
      this.setState({ emojiPickerIsOpen: true });
    }
  };

  closeEmojiPicker = (e) => {
    if (this.emojiPickerButton.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState({ emojiPickerIsOpen: false });
  };

  _submitText(event) {
    event.preventDefault();
    const text = this.userInput.textContent;
    const { onSubmit } = this.props;
    if (text && text.length > 0) {
      onSubmit({
        author: "me",
        type: "TEXT",
        data: { text },
      });
      this.userInput.innerHTML = "";
      this.setState({ inputHasText: false });
    }
  }

  _onFilesSelected(event) {
    const { onFilesSelected } = this.props;
    if (event.target.files && event.target.files.length > 0) {
      onFilesSelected(event.target.files);
    }
  }

  _handleEmojiPicked = (emoji) => {
    const { inputHasText, onSubmit } = this.props;
    this.setState({ emojiPickerIsOpen: false });
    if (inputHasText) {
      this.userInput.innerHTML += emoji;
    } else {
      onSubmit({
        author: "me",
        type: "emoji",
        data: { emoji },
      });
    }
  };

  handleEmojiFilterChange = (event) => {
    const emojiFilter = event.target.value;
    this.setState({ emojiFilter });
  };
  _renderSendOrFileIcon() {
    const { supportedExtensions } = this.state;
    if (this.state.inputHasText) {
      return (
        <div className="sc-user-input--button">
          <SendIcon onClick={this._submitText.bind(this)} />
        </div>
      );
    }
    return (
      <div className="sc-user-input--button">
        <FileIcon onClick={this._showFilePicker.bind(this)} />
        <Input
          type="file"
          name="files[]"
          accept={supportedExtensions}
          ref={(e) => {
            this._fileUploadButton = e;
          }}
          onChange={this._onFilesSelected.bind(this)}
        />
      </div>
    );
  }

  handlePlayToggle() {
    const { record } = this.state;
    this.setState({
      record: !record,
    });
    if (this.state.playing) {
      if (this.audioCtx === undefined) {
        const audioCtx = window.AudioContext || window.webkitAudioContext;
        this.audioCtx = new audioCtx();
      }
      this.audioCtx.resume();
    } else {
      if (this.audioCtx === undefined) {
        const audioCtx = window.AudioContext || window.webkitAudioContext;
        this.audioCtx = new audioCtx();
      }
      this.audioCtx.suspend();
    }
  }

  onStop(recordedBlob) {
    const { onSubmit } = this.props;
    onSubmit({
      author: "me",
      type: "VOICE",
      data: { recordedBlob },
    });
  }

  render() {
    const { inputActive } = this.state;
    const { locale } = this.props;
    return (
      <form className={`sc-user-input ${inputActive ? "active" : ""}`}>
        <div
          role="button"
          tabIndex="0"
          onFocus={() => {
            this.setState({ inputActive: true });
          }}
          onBlur={() => {
            this.setState({ inputActive: false });
          }}
          ref={(e) => {
            this.userInput = e;
          }}
          onKeyDown={this.handleKeyDown.bind(this)}
          onKeyUp={this.handleKeyUp.bind(this)}
          contentEditable="true"
          placeholder={locale === "ar" ? "اكتب رد ..." : "Write a reply..."}
          className="sc-user-input--text"
        />
        <div
          className={`${locale === "ar" ? "rtl " : " "}sc-user-input--buttons`}
        >
          <div className="sc-user-input--button" />
          <div className="sc-user-input--button"></div>
          {this._renderSendOrFileIcon()}
        </div>
      </form>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func.isRequired,
};

export default UserInput;
